import React, { Component } from 'react';

import locationIcon from '../images/location_icon.png';
import calendarIcon from '../images/calendar_icon.png';
import editIcon from '../images/edit_icon.png';
import tickIcon from '../images/tick_icon.png';

import leftArrow from '../images/left_arrow.png';

import Parser from 'html-react-parser';
import swal from 'sweetalert';

class PreviewCoupons extends Component {

  constructor(props) {
    super(props);
    this.refresh_prices = this.refresh_prices.bind(this);
    this.page_handler = this.page_handler.bind(this);
    this.page_handler_details = this.page_handler_details.bind(this);
    this.state = {
      error: null,
      isLoaded: false,
      page_num: 3,
      childVisible: false,
      total_ticket_count: -1,
      total_offer_count: -1,
      total_ticket_price: -1,
      total_cost_price: -1,
      total_conv_fee: -1,
      total_total_tax: -1,
      total_offer_price: -1,
      total_total_amount: -1,
      coupon_struct: []
    }
  }

  componentDidMount(){

    window.scrollTo(0, 0); //scroll to top on page change

      fetch("https://checkout-api"+this.props.sandbox_url_creator+".highape.com/web/v1/get_preview_detail?order_hashed_id=" + this.props.order_id + "&access_token="+this.props.access_token)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            total_ticket_count: result['Total_ticket_count'],
            total_offer_count: result['Total_offer_count'],
            total_ticket_price: result['Total_ticket_price'],
            total_cost_price: result['Total_cost_price'],
            total_conv_fee: result['Total_conv_fee'],
            total_total_tax: result['Total_total_tax'],
            total_offer_price: result['Total_offer_price'],
            total_total_amount: result['Total_total_amount'],
            coupon_struct: result['Coupon_struct']
          });
          //alert(this.state.total_offer_price);
          //alert(JSON.stringify(result['Coupon_struct']));
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      );
  }


  page_handler() {
    if(this.state.total_total_amount>-1){ //sometimes if the net is slow, the api does not respond and the amount stays -1, dont let users proceed in those cases
      this.props.main_page_change(4, this.state.total_total_amount);
    }
  }

  page_handler_details() {
    this.props.main_page_details_change(2);
  }

  refresh_prices(cost_price, total_amount){
    this.setState({
      total_cost_price: cost_price,
      total_total_amount: total_amount
    });
  }

  render() {
    //var total_pass_count = this.state.total_ticket_count;
    return (
	      <div className={this.props.name_of_class} id="preview_page_main_div">
	        <EventDetails event_name={this.props.event_name} event_date={this.props.event_date} event_image={this.props.event_image} event_venue_name={this.props.event_venue_name} event_locality={this.props.event_locality} event_city={this.props.event_city} occurrence_date={this.props.occurrence_date} tickets_selected={this.props.tickets_selected} ticket_count={this.state.total_ticket_count}/>
	        <BlankSpace blank_space_css_count="2"/>
	        <PriceDisplay event_currency={this.props.event_currency} event_currency_icon={this.props.event_currency_icon} total_ticket_price={this.state.total_ticket_price} total_cost_price={this.state.total_cost_price} total_conv_fee={this.state.total_conv_fee} total_total_tax={this.state.total_total_tax} total_offer_price={this.state.total_offer_price} total_total_amount={this.state.total_total_amount} />
	        <CouponArea sandbox_url_creator={this.props.sandbox_url_creator} access_token={this.props.access_token} order_id={this.props.order_id} ticket_token={this.props.ticket_token} refresh_prices={this.refresh_prices} coupon_struct={this.state.coupon_struct} />
	        <LastArea special_note={this.props.special_note}/>
          <BlankSpace blank_space_css_count="1"/>
	        <TicketUserDetail user_email={this.props.user_email} user_phone={this.props.user_phone} page_change_details={this.page_handler_details} />
          <BlankSpace blank_space_css_count="1"/>
	        <FooterPrevPage page_change={this.page_handler} event_tc={this.props.event_tc} />
	      </div>
    );
  }
}


class EventDetails extends Component {

  constructor() {
    super();
    this.state = {
      childVisible: false
    }
  }

  render() {
/*
    var date_to_show = this.props.event_date;
    if(this.props.occurrence_date != "0") {
      date_to_show = this.props.occurrence_date;
      let start_date = new Date(date_to_show).toDateString();
      let start_time = new Date(date_to_show).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
      //let end_time = new Date(date_to_show).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
      date_to_show = start_date + " " + start_time;
    }
*/
    return (
      <div className="event_details_preview col-sm-12 col-xs-12">
        <div className="col-sm-12 col-xs-12 main_event_det_prev">
          <div className="col-sm-4 col-xs-4 event_image_div">
            <img className="event_image_preview" alt="event" src={this.props.event_image} />
          </div>
          <div className="col-sm-8 col-xs-8 venue_date_prev">
          <span className="display_block venue_prev_disp_mob event_name_disp_new">{this.props.event_name}</span>
            <span className="display_block venue_prev_disp_mob">  {this.props.event_venue_name} • {this.props.event_locality} • {this.props.event_city}</span>
            <span className="hide_this"><img className="calendar_icon" alt="Icon for Calendar" src={calendarIcon} />  {this.props.event_date}</span>
          </div>
        </div>
        <div className="clearfix"></div>
        <div className="col-sm-12 col-xs-12 main_event_det_prev sel_passes_main_prev">
          <div className="col-sm-12 col-xs-12 selected_passes_title">
            Selected Passes
          </div>
          <div className="col-sm-9 col-xs-9 tick_sel_main">
            {this.props.tickets_selected}
          </div>
          <div className="col-sm-3 col-xs-3 preview_pass_count">
            <p className="prev_tot_pass_count">{this.props.ticket_count}</p>
            <p>Total Passes</p>
          </div>
        </div>
      </div>
    );
  }

}


class BlankSpace extends Component {
  render() {
    let name_of_class = "col-sm-12 col-xs-12 blank_space" + this.props.blank_space_css_count;
    return (
      <div className={name_of_class}>
      </div>
    );
  }
}

class PriceDisplay extends Component {

  constructor() {
    super();
    this.state = {
      childVisible: false,
    }
  }

  render() {
    let ticket_price = this.props.total_ticket_price;
    let cost_price = this.props.total_cost_price;
    let discount_price = ticket_price - cost_price;
    discount_price = Math.round(discount_price * 100) / 100; //rounding off discount amount
    let conv_fee = this.props.total_conv_fee;
    let total_tax = this.props.total_total_tax;
    let offer_price = this.props.total_offer_price;
    let total_amount = this.props.total_total_amount;
    let platform_fee = Math.round((this.props.total_conv_fee + this.props.total_total_tax) * 100)/100;

    let subtotal_price = ticket_price + offer_price;

    var currency_icon = Parser(this.props.event_currency_icon);

    return (
      <div className="col-sm-12 col-xs-12 pricing_div">
        <div className="child_pricing_div">
          <span className="col-sm-7 col-xs-7 subtotal_span">Subtotal:</span><span className="col-sm-5 col-xs-5 subtotal_span amount_align">{currency_icon} {subtotal_price}</span><br />
          
          {(() => { //for publishing the discount amount
                if(discount_price>0){
                  return (<div><span className="col-sm-7 col-xs-7 conv_fee_span">Coupon Applied:</span><span className="col-sm-5 col-xs-5 amount_align">{currency_icon} {discount_price}</span><br /></div>)
                }
          })()}
          <span className="col-sm-7 col-xs-7 conv_fee_span">Platform Fee + Taxes:</span><span className="col-sm-5 col-xs-5 amount_align">{currency_icon} {platform_fee}</span><br />
          <span className="col-sm-7 col-xs-7 show_breakup" onClick={() => this.onClick()}>Show Breakup</span><span className="col-sm-5 col-xs-5 amount_align"></span><br />
          <div className="col-sm-12 col-xs-12 show_breakup_child">
          {
            this.state.childVisible
              ? <div><span className="col-sm-7 col-xs-7 conv_fee_span convenince_fee_text_span">Platform/Convenience Fee:</span><span className="col-sm-5 col-xs-5 amount_align show_breakup_amount_span">{currency_icon} {conv_fee} </span><span className="col-sm-7 col-xs-7 conv_fee_span tax_breakup_span">CGST+SGST/IGST</span><span className="col-sm-5 col-xs-5 amount_align show_breakup_amount_span">{currency_icon} {total_tax}</span></div>
              : null
          }
          </div>
          <span className="col-sm-7 col-xs-7 total_amount_span">Total:</span><span className="col-sm-5 col-xs-5 amount_align">{currency_icon} {total_amount}</span><br />
        </div>
      </div>
    );
  }

  onClick() {
    this.setState(prevState => ({ childVisible: !prevState.childVisible }));
  }

}


class CouponArea extends Component {

  constructor(props){
    super(props);
    this.state = {
      red: true,
      coupon_struct_list: []
    }
    //alert(this.props.coupon_struct);
  }

  componentDidMount(){

  }

  changeColor(){
    this.setState({red: !this.state.red})
  }

  render() {

  	var coupon_struct_list = [];
  	let coupon_struct = this.props.coupon_struct;
  	//alert(this.props.coupon_struct);
  	for(var c = 0; c<coupon_struct.length; c++){
  		let coupon_parent_id = "coupon_parent_" + c;
  		let coupon_name = coupon_struct[c]["name"];
  		coupon_struct_list.push(<div id={coupon_parent_id} className="col-sm-12 col-xs-12 coupon_struct_parent_div radio">
  			<input  onClick={() => this.apply_coupon_code(coupon_name)} className="coupon_struct_radio" type="radio" name="coupon_name" value={coupon_struct[c]["name"]} />
  			<span className="coupon_struct_text">{coupon_struct[c]["Coupon_text"]}</span>
  			</div>
  			);
  	}

    let btn_class = this.state.red ? "row coupon_box_red" : "row coupon_box_green";

    return(
      <div className="col-sm-12 col-xs-12">
        <div className={btn_class}>
          <div className="col-sm-8 col-xs-8">
            <input type="text" name="coupon_code" className="input_box_coupon" onFocus={this.changeColor.bind(this)} id="coupon_code" placeholder="Apply Coupon" required />
          </div>
          <div className="col-sm-4 col-xs-4">
            <input type="button" name="apply_coupon_btn" onClick={() => this.apply_coupon_click()} className="apply_coupon_class" id="apply_coupon_btn" value="Apply" required />
            <div id="applying_coupon_text" className="applying_coupon_text_desktop">Applying...</div>
          </div>
        </div>
        <div>
        	{coupon_struct_list}
        </div>
      </div>
    );
  }

  apply_coupon_code(coupon_code){

  	document.getElementById("coupon_code").value = coupon_code;
  	document.getElementById("apply_coupon_btn").click();

  }

  apply_coupon_click(){

    document.getElementById('apply_coupon_btn').style.display = 'none';
    document.getElementById('applying_coupon_text').style.display = 'block';

    let coupon_code = document.getElementById("coupon_code").value;

    if(coupon_code.length > 0){

      let order_id = this.props.order_id;

      var coupon_array = {"access_token": this.props.access_token, "ticket_token": this.props.ticket_token, "order_hashed_id": order_id, "coupon_code": coupon_code}

      var final_coupon_data = JSON.stringify(coupon_array);

      fetch('https://checkout-api'+this.props.sandbox_url_creator+'.highape.com/web/v1/apply_coupon', {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: final_coupon_data
      })
        .then(function(response) {
            return response.json()
        }).then(function(result) {
            if(result["Coupon_success"]===1){
              //alert(result["Coupon_msg"]);
              swal(result["Coupon_msg"]);
              this.props.refresh_prices(result["Total_cost_price"], result["Total_total_amount"]);
              document.getElementById('apply_coupon_btn').style.display = 'block';
              document.getElementById('applying_coupon_text').style.display = 'none';
            }else{
              //alert(result["Coupon_msg"]);
              swal(result["Coupon_msg"]);
              document.getElementById('apply_coupon_btn').style.display = 'block';
              document.getElementById('applying_coupon_text').style.display = 'none';
              //this.props.refresh_prices(result["Total_cost_price"], result["Total_total_amount"]);
            }
        }.bind(this));
    }else{
      swal("Please enter a coupon code first!");
      document.getElementById('apply_coupon_btn').style.display = 'block';
      document.getElementById('applying_coupon_text').style.display = 'none';
    }
  }
}


class LastArea extends Component {

  render() {
    return(
      <div className="col-sm-12 col-xs-12 special_note_div">
        <p className="special_note_title">Special Event Details</p>
        <p className="special_note_text">{this.props.special_note}</p>
      </div>
    );
  }
}

class TicketUserDetail extends Component {
  render() {
    return (
      <div>
        <div className="col-sm-12 col-xs-12 ticket_confirmation_personal_div">
          <div className="col-sm-9 col-xs-9 ticket_conf_child_det">
            <p className="ticket_conf_title">Ticket confirmation to</p>
            <p className="ticket_conf_email">{this.props.user_email}</p>
            <p className="ticket_conf_phone">{this.props.user_phone}</p>
          </div>
          <div className="col-sm-3 col-xs-3">
            <img className="edit_icon_image"  onClick={this.props.page_change_details} src={editIcon} alt="Edit details" />
          </div>
        </div>
      </div>
    );
  }
}


class FooterPrevPage extends Component {

  render() {
    return (
      <div>
        <div className="conf_footer col-sm-12 col-xs-12">
          <p className="conf_footer_text"><img src={tickIcon} alt="Agreed T&C" /> By Clicking on Next, you agree to the <span className="tc_prev_page" onClick={() => this.onClickOpentc(this.props.event_tc)} >Terms & Conditions</span>.</p>
          <p className="below_continue_back_mob" onClick={() => this.triggerHeaderClick()} ><img src={leftArrow} className="left_back_icon" alt="Left Arrow Icon"/>Back</p>
        </div>
        <div className="clearfix"></div>
        <div className="col-sm-12 col-xs-12 next_ticket_main_div">
          <div className="col-sm-12 col-xs-12 next_ticket_click" onClick={this.props.page_change} >
            Continue
          </div>
        </div>
      </div>
    );
  }

  onClickOpentc(event_tc){
    var event_tc_strip_html = event_tc.replace(/<(?:.|\n)*?>/gm, '');
    swal(event_tc_strip_html);
  }

  triggerHeaderClick() {
    document.getElementById("second_journey_main").click();
  }

}


export default PreviewCoupons;


// WEBPACK FOOTER //
// ./src/mobile/mobPreviewCoupons.js